import { call, put } from "redux-saga/effects";
import { ACTIONS, APIS, KEYS, STORAGE } from "../../_config";
import { CallApi } from "../api/callApi";
import { sagaFunction } from "../api/functions";

export function* searchAttribute(action: any): any {
    yield call(sagaFunction, action, CallApi.GET, APIS.ATTRIBUTES.SEARCH_ATTRIBUTE, action.payload, true);
}

export function* addUpdateAttribute(action: any): any {
    yield call(sagaFunction, action, CallApi.POST, APIS.ATTRIBUTES.ADD_UPDATE_ATTRIBUTE, action.payload, true);
}

export function* deleteAttribute(action: any): any {
    yield call(sagaFunction, action, CallApi.POST, APIS.ATTRIBUTES.DELETE_ATTRIBUTE, action.payload, true);
}

export function* attributeDetails(action: any): any {
    yield call(sagaFunction, action, CallApi.GET, APIS.ATTRIBUTES.ATTRIBUTE_DETAILS, action.payload, true);
}
